module.exports = __webpack_public_path__ + "static/media/passport-circle.32148f81.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/passport-circle.svg
 ** module id = 1285
 ** module chunks = 0
 **/